import {
    PARTNUMBER_DELETE_OPEN_MODAL,
    PARTNUMBER_DELETE_REQUEST,
    PARTNUMBER_DELETE_RESULT,
} from 'Redux/actionTypes';

export const partNumberOpenModal = (data) => ({
    type: PARTNUMBER_DELETE_OPEN_MODAL,
    payload: data,
})

export const partNumberRequest = (data) => ({
    type: PARTNUMBER_DELETE_REQUEST,
    payload: data,
})

export const partNumberResult = (result) => ({
    type: PARTNUMBER_DELETE_RESULT,
    payload: result
})